<template>
  <div>
    <Layout/>
    <h4>Médico</h4>
<!-- Master -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idMedico" class="form-label">IdMedico</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idMedico" name="idMedico" v-model="datoMedico.idMedico" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idPersona" class="form-label"> Persona</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idPersona" name="idPersona" v-model="datoMedico.idPersona">
                      <option v-for="persona in personas" :value="persona.idPersona" :key="persona.idPersona">
                        {{ persona.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idEspecialidad" class="form-label"> Especialidad</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idEspecialidad" name="idEspecialidad" v-model="datoMedico.idEspecialidad">
                      <option v-for="especialidad in especialidads" :value="especialidad.idEspecialidad" :key="especialidad.idEspecialidad">
                        {{ especialidad.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idUsuarioReg" class="form-label">IdUsuarioReg</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idUsuarioReg" name="idUsuarioReg" v-model="datoMedico.idUsuarioReg" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idUsuarioAct" class="form-label">IdUsuarioAct</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idUsuarioAct" name="idUsuarioAct" v-model="datoMedico.idUsuarioAct" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaAct" class="form-label">FechaAct</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaAct" name="fechaAct" v-model="datoMedico.fechaAct" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaReg" class="form-label">FechaReg</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaReg" name="fechaReg" v-model="datoMedico.fechaReg" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="documento" class="form-label">Documento</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="documento" name="documento" v-model="datoMedico.documento" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="tituloProfesional" class="form-label">TituloProfesional</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="tituloProfesional" name="tituloProfesional" v-model="datoMedico.tituloProfesional" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="tituloEspecialidad" class="form-label">TituloEspecialidad</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="tituloEspecialidad" name="tituloEspecialidad" v-model="datoMedico.tituloEspecialidad" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <button type="submit" class="btn btn-light" @click.prevent="guardarMedico" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditMedico" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>

<!-- Details -->
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">IdReferencia</th>
          <th scope="col">IdMotivoRef</th>
          <th scope="col">IdEmpresaOrigen</th>
          <th scope="col">IdEmpresaDestino</th>
          <th scope="col">IdPersona</th>
          <th scope="col">IdMedico</th>
          <th scope="col">FechaReg</th>
          <th scope="col">FechaRef</th>
          <th scope="col">Hora</th>
          <th scope="col">Tipo</th>
          <th scope="col">Motivo</th>
          <th scope="col">Resumen</th>
          <th scope="col">Hallazgos</th>
          <th scope="col">Tratamiento</th>
          <th scope="col">Justificada</th>
          <th scope="col">Estado</th>
          <th scope="col">PersonaFechaReg</th>
          <th scope="col">MotivoRefNombre</th>
          <th scope="col">MedicoFechaReg</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="referencia in datosPaginados" :key="referencia.idReferencia">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(referencia.idReferencia)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(referencia.idReferencia)" title="Editar">edit_square</i></td>
          <td>{{referencia.idReferencia}}</td>
          <td>{{referencia.idMotivoRef}}</td>
          <td>{{referencia.idEmpresaOrigen}}</td>
          <td>{{referencia.idEmpresaDestino}}</td>
          <td>{{referencia.idPersona}}</td>
          <td>{{referencia.idMedico}}</td>
          <td>{{getFormattedDate(referencia.fechaReg, 'DD/MM/YYYY')}}</td>
          <td>{{getFormattedDate(referencia.fechaRef, 'DD/MM/YYYY')}}</td>
          <td>{{referencia.hora}}</td>
          <td>{{referencia.tipo}}</td>
          <td>{{referencia.motivo}}</td>
          <td>{{referencia.resumen}}</td>
          <td>{{referencia.hallazgos}}</td>
          <td>{{referencia.tratamiento}}</td>
          <td>{{referencia.justificada}}</td>
          <td>{{referencia.estado}}</td>
          <td>{{getFormattedDate(referencia.personaFechaReg, 'DD/MM/YYYY')}}</td>
          <td>{{referencia.motivoRefNombre}}</td>
          <td>{{getFormattedDate(referencia.medicoFechaReg, 'DD/MM/YYYY')}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteMedico(referencia.idReferencia)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idReferencia" class="form-label">IdReferencia</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idReferencia" name="idReferencia" v-model="datoReferencia.idReferencia" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <div class="row">
                  <div class="col-2">
                    <label for="idAtencion" class="form-label"> Atencion</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idAtencion" name="idAtencion" v-model="datoReferencia.idAtencion">
                      <option v-for="atencion in atencions" :value="atencion.idAtencion" :key="atencion.idAtencion">
                        {{ atencion.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <div class="row">
                  <div class="col-2">
                    <label for="idMotivoRef" class="form-label"> Motivo Ref</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idMotivoRef" name="idMotivoRef" v-model="datoReferencia.idMotivoRef">
                      <option v-for="motivoRef in motivoRefs" :value="motivoRef.idMotivoRef" :key="motivoRef.idMotivoRef">
                        {{ motivoRef.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <div class="row">
                  <div class="col-2">
                    <label for="idEmpresaOrigen" class="form-label"> Empresa Origen</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idEmpresaOrigen" name="idEmpresaOrigen" v-model="datoReferencia.idEmpresaOrigen">
                      <option v-for="empresaOrigen in empresaOrigens" :value="empresaOrigen.idEmpresaOrigen" :key="empresaOrigen.idEmpresaOrigen">
                        {{ empresaOrigen.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <div class="row">
                  <div class="col-2">
                    <label for="idEmpresaDestino" class="form-label"> Empresa Destino</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idEmpresaDestino" name="idEmpresaDestino" v-model="datoReferencia.idEmpresaDestino">
                      <option v-for="empresaDestino in empresaDestinos" :value="empresaDestino.idEmpresaDestino" :key="empresaDestino.idEmpresaDestino">
                        {{ empresaDestino.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <div class="row">
                  <div class="col-2">
                    <label for="idPersona" class="form-label"> Persona</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idPersona" name="idPersona" v-model="datoReferencia.idPersona">
                      <option v-for="persona in personas" :value="persona.idPersona" :key="persona.idPersona">
                        {{ persona.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idMedico" class="form-label">IdMedico</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idMedico" name="idMedico" v-model="datoReferencia.idMedico" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaReg" class="form-label">FechaReg</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaReg" name="fechaReg" v-model="datoReferencia.fechaReg" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaRef" class="form-label">FechaRef</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaRef" name="fechaRef" v-model="datoReferencia.fechaRef" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="hora" class="form-label">Hora</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="hora" name="hora" v-model="datoReferencia.hora" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="tipo" class="form-label">Tipo</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="tipo" name="tipo" v-model="datoReferencia.tipo" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="motivo" class="form-label">Motivo</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="motivo" name="motivo" v-model="datoReferencia.motivo" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="resumen" class="form-label">Resumen</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="resumen" name="resumen" v-model="datoReferencia.resumen" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="hallazgos" class="form-label">Hallazgos</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="hallazgos" name="hallazgos" v-model="datoReferencia.hallazgos" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="tratamiento" class="form-label">Tratamiento</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="tratamiento" name="tratamiento" v-model="datoReferencia.tratamiento" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="justificada" class="form-label">Justificada</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="justificada" name="justificada" v-model="datoReferencia.justificada" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarReferencia" v-if="btnCrear_det" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditReferencia" v-if="btnEditar_det" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Details -->

    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import { validarForm } from '@/modules/validacionesForms.js';
import dateFormat from '@/modules/dateFormat.js';
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
  },
  data () {
    return {
// Variables master
      medicos : [],
      datoMedico : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idMedico: '',
      personas : [],
      especialidads : [],
// Variables master
// Variables details
      referencias : [],
      datoReferencia : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      atencions : [],
      motivoRefs : [],
      empresaOrigens : [],
      empresaDestinos : [],
      modalWindow: true
// Variables details
    }
  },
  mounted () {
    this.p_idMedico = this.$route.params.p_idmedico
    this.abrirEditar(this.p_idMedico)
    this.getDataPagina(this.paginaActual)
    this.fetchPersonas()
    this.fetchEspecialidads()
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
// Procedimientos master
    validarForm(){
      const requiredFields = [
        'idPersona'
        ,'idEspecialidad'
        ,'documento'
        ,'tituloProfesional'
        ,'tituloEspecialidad'
      ];
      const requiredFieldsText = [
        'idPersona'
        ,'idEspecialidad'
        ,'documento'
        ,'tituloProfesional'
        ,'tituloEspecialidad'
      ];
      return validarForm(this.datoMedico, requiredFields, requiredFieldsText);
    },
    async guardarMedico(){
      if(this.validarForm() === 1){
        try {
          await api.post('/medicos', this.datoMedico)
          swal("Correcto!", "Medico creada exitosamente!", "success");
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditMedico(){
      if(this.validarForm() === 1){
        try {
          await api.post('/medicos', this.datoMedico)
          swal("Correcto!", "Medico creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirCrear(){
      this.modalWindow = true
      this.datoMedico={}
      this.titulo   = 'Crear Médico'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirEditar(idMedico){
      this.modalWindow = true
      if(idMedico != null){    
           api.get('/vwmedicos/'+idMedico).then(resp=>{
          this.datoMedico = resp.data;
           });
      }
      this.titulo   = 'Editar Médico'
      this.btnCrear = false
      this.btnEditar= true
    },
    cerrarMedico(){
      this.$router.push('/Medico')
    },
// Procedimientos master
// Procedimientos detalle
    totalPaginas(){
      return Math.ceil(this.referencias.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwreferencias/nombre/'+this.nombreBusqueda).then(response=>{
          this.referencias=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.referencias.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwreferencias').then(response=>{
      this.referencias=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.referencias.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet(){
      const requiredFields = [
        'idPersona'
        ,'idEspecialidad'
        ,'documento'
        ,'tituloProfesional'
        ,'tituloEspecialidad'
      ];
      const requiredFieldsText = [
        'idPersona'
        ,'idEspecialidad'
        ,'documento'
        ,'tituloProfesional'
        ,'tituloEspecialidad'
      ];
      return validarForm(this.datoMedico, requiredFields, requiredFieldsText);
    },
    async guardarReferencia(){
      if(this.validarForm() === 1){
        try {
          this.datoReferencia.idMedico = this.datoMedico.idMedico;
          await api.post('/referencias', this.datoReferencia)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "Referencia creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditReferencia(){
      if(this.validarForm() === 1){
        try {
          await api.post('/referencias', this.datoReferencia)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "Referencia creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoReferencia={}
      this.titulo   = 'Crear Médico'
      this.btnCrear_det  = true
      this.btnEditar_det = false
    },
    abrirModalEditar(idReferencia){
      this.modalWindow = true
      if(idReferencia != null){    
           api.get('/vwreferencias/'+idReferencia).then(resp=>{
          this.datoReferencia = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Médico'
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
    abrirEditarDet(idReferencia){
      this.modalWindow = true
      if(idReferencia != null){
        this.$router.push('/referenciamd/'+idReferencia)
      }
    },
    async deleteReferencia (idReferencia) {
      try{
        await api.delete('/referencias/'+idReferencia)
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
// Procedimientos detalle
    fetchPersonas() {
      fetch('http://localhost:8080/api/v1/personas')
        .then(response => response.json())
        .then(data => {
          this.personas = data;
        })
        .catch(error => {
          console.error('Error fetching personas:', error);
        });
    },
    fetchEspecialidads() {
      fetch('http://localhost:8080/api/v1/especialidads')
        .then(response => response.json())
        .then(data => {
          this.especialidads = data;
        })
        .catch(error => {
          console.error('Error fetching especialidads:', error);
        });
    },
    fetchAtencions() {
      fetch('http://localhost:8080/api/v1/atencions')
        .then(response => response.json())
        .then(data => {
          this.atencions = data;
        })
        .catch(error => {
          console.error('Error fetching atencions:', error);
        });
    },
    fetchMotivoRefs() {
      fetch('http://localhost:8080/api/v1/motivorefs')
        .then(response => response.json())
        .then(data => {
          this.motivoRefs = data;
        })
        .catch(error => {
          console.error('Error fetching motivoRefs:', error);
        });
    },
    fetchEmpresaOrigens() {
      fetch('http://localhost:8080/api/v1/empresaorigens')
        .then(response => response.json())
        .then(data => {
          this.empresaOrigens = data;
        })
        .catch(error => {
          console.error('Error fetching empresaOrigens:', error);
        });
    },
    fetchEmpresaDestinos() {
      fetch('http://localhost:8080/api/v1/empresadestinos')
        .then(response => response.json())
        .then(data => {
          this.empresaDestinos = data;
        })
        .catch(error => {
          console.error('Error fetching empresaDestinos:', error);
        });
    },
  },
}
</script>
